import { useFuriPairs, Wrapper, Pair, Text, Furi } from 'react-furi';

const WordWithFurigana = ({ word, verFurigana, verRomaji, isTitle = false }) => {
    const pairs = useFuriPairs(word.word, word.reading);
    
    const textSizeClasses = isTitle 
        ? "text-2xl sm:text-3xl md:text-4xl lg:text-5xl" 
        : "text-lg sm:text-xl md:text-2xl lg:text-3xl";
    
    const furiSizeClasses = isTitle 
        ? "text-sm sm:text-base" 
        : "text-xs sm:text-sm";
    
    return (
        <div className='inline-block font-japanese text-center'>
            <div className='flex flex-col items-center'>
                <span className={`drop-shadow-sm ${textSizeClasses} text-center`}>
                    {verFurigana ?
                    <Wrapper>
                        {pairs.map(([furiText, text], pairIndex) => (
                            <Pair key={text + pairIndex}>
                                <Furi className={`${furiSizeClasses} text-primary-600 text-center`}>{furiText}</Furi>
                                <Text className={`${textSizeClasses} text-center`}>{text}</Text>
                            </Pair>
                        ))}
                    </Wrapper>
                    :
                    word.word
                    }
                </span>
            </div>
            <div>
                {verRomaji && (
                    <div className={`text-sm text-gray-500 ${word.romaji === "empty" ? "invisible" : ""} text-center`}>
                        {word.romaji}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WordWithFurigana;